import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = { class: "mt-3 float-right" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kaikei_kijun_setting_title = _resolveComponent("kaikei-kijun-setting-title")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_hikiatekin_setting_item = _resolveComponent("hikiatekin-setting-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _createVNode(_component_kaikei_kijun_setting_title, { "main-title": "引当金明細表" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          disabled: !_ctx.isAllValid,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createBlock(_component_hikiatekin_setting_item, {
            key: item.item.id,
            item: item,
            "is-first": index === 0,
            "is-last": index === (_ctx.items.length - 1),
            onUpItem: _ctx.upItem,
            onDownItem: _ctx.downItem,
            onTrashItem: _ctx.trashItem,
            onChangeInput: _ctx.onChangeInput
          }, null, 8, ["item", "is-first", "is-last", "onUpItem", "onDownItem", "onTrashItem", "onChangeInput"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args))),
          disabled: _ctx.items.length >= 10
        }, "項目を追加", 8, _hoisted_4)
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}